import { render, staticRenderFns } from "./QuizAnswer.vue?vue&type=template&id=820ed0c6&scoped=true&lang=pug&"
import script from "./QuizAnswer.vue?vue&type=script&lang=js&"
export * from "./QuizAnswer.vue?vue&type=script&lang=js&"
import style0 from "./QuizAnswer.vue?vue&type=style&index=0&id=820ed0c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820ed0c6",
  null
  
)

component.options.__file = "QuizAnswer.vue"
export default component.exports